var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseApplyRecordService } from '~/services/domain-service/case-apply-record.service';
import { Prop, Emit, Watch } from "vue-property-decorator";
import SvgIcon from "~/components/common/svg-icon.vue";
var CheckConfirm = /** @class */ (function (_super) {
    __extends(CheckConfirm, _super);
    function CheckConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.status = null;
        return _this;
    }
    CheckConfirm.prototype.emitSuccess = function () { };
    CheckConfirm.prototype.emitClose = function () { };
    CheckConfirm.prototype.onMessageDataChange = function (val) {
        if (!val || !val.messageModels)
            return;
        this.dataSet = val.messageModels.map(function (v) { return (__assign(__assign({}, v), { show: false })); });
        this.status = val.status;
    };
    __decorate([
        Dependencies(CaseApplyRecordService)
    ], CheckConfirm.prototype, "caseApplyRecordService", void 0);
    __decorate([
        Prop({ required: true, type: Object })
    ], CheckConfirm.prototype, "messageData", void 0);
    __decorate([
        Emit("success")
    ], CheckConfirm.prototype, "emitSuccess", null);
    __decorate([
        Emit("close")
    ], CheckConfirm.prototype, "emitClose", null);
    __decorate([
        Watch('messageData', { immediate: true })
    ], CheckConfirm.prototype, "onMessageDataChange", null);
    CheckConfirm = __decorate([
        Component({
            components: {
                SvgIcon: SvgIcon
            },
        })
    ], CheckConfirm);
    return CheckConfirm;
}(Vue));
export default CheckConfirm;
